// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.help-text {
  white-space: pre-line;
  line-height: 24px;
  font-size: 14px;
  font-family: 'Ubuntu';
  letter-spacing: 0.44px;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/farmer-devices/farmer-create-device.ts"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["\n.help-text {\n  white-space: pre-line;\n  line-height: 24px;\n  font-size: 14px;\n  font-family: 'Ubuntu';\n  letter-spacing: 0.44px;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
